import { Info } from '@mui/icons-material';
import { Alert } from '@mui/material';

type StatementAlertProps = {
  statement: string;
};

const StatementAlert: React.FC<StatementAlertProps> = ({ statement }) => {
  return (
    <Alert
      variant="filled"
      severity="info"
      icon={<Info fontSize="inherit" color="primary" />}
      sx={{
        bgcolor: 'yellow.100',
        color: 'black',
        boxShadow: '2px 2px 5px 0px rgba(0,0,0,0.1)',
      }}
    >
      คำชี้แจง: {statement}
    </Alert>
  );
};

export default StatementAlert;
